import type { BudgetCategory } from '../types/ui/Budget';
import { refreshBudgetFromApi } from './budgetStorage';
import { refreshTasksFromApi, type Task } from '../services/TasksService';
import { BUDGET_ENABLED } from '../constants/featureFlags';

export interface DashboardData {
  tasks: Task[];
  budgetCategories: BudgetCategory[];
  /** false when the budget could not be read: the API is failing, or this person may not see money (403), or Budget is switched off. */
  budgetAvailable: boolean;
}

/**
 * Tasks are required: a failure is thrown so the page shows its Retry box.
 * Budget is optional: a failure must not hide the whole dashboard, and must not
 * read as zeros either, so the page gets `budgetAvailable: false` and leaves the
 * Budget Overview out. When the API works the Overview is shown, even if the
 * project has no categories yet. With BUDGET_ENABLED off the budget is not asked for.
 */
export async function loadDashboardData(): Promise<DashboardData> {
  const [tasks, budget] = await Promise.all([
    refreshTasksFromApi({ strict: true }),
    (BUDGET_ENABLED ? refreshBudgetFromApi({ strict: true }) : Promise.reject(new Error('budget is switched off'))).then(
      (budgetCategories) => ({ budgetCategories, budgetAvailable: true }),
      () => ({ budgetCategories: [] as BudgetCategory[], budgetAvailable: false }),
    ),
  ]);
  return { tasks, ...budget };
}
